import CTNEllipsis from '@ctn/ui/components/ctn-ellipsis';

import { SOLICITUD_ESTADOS_COLOR } from '@/constants/tramite.constants';
import { type ILookup } from '@/interfaces/model/generic.interface';
import { type ISolicitud } from '@/interfaces/model/solicitudes.interface';
import type { CustomColumnDef } from '@ctn/ui/types/ctn-table';

import TextIcon from '../TextIcon';

const setColumn = <K extends keyof ISolicitud  >(
	key: K,
	header: string,
	width?: number,
	customCell?: CustomColumnDef<ISolicitud>['cell']
): CustomColumnDef<ISolicitud> => ({
	accessorKey: key as string,
	header,
	enableSorting: false,
	...(width ? { th: { width } } : {}),
	responsive: { sizeColumn: 'full' },
	cell: customCell ?? (({ getValue }) => <CTNEllipsis content={getValue() as string} />),
});

const getColumns = (): Array<CustomColumnDef<ISolicitud>> => [
	setColumn('numeroTramiteExterno', 'Nº solicitud', 164),
	setColumn('fechaCreacion', 'Fecha alta', 164),
	setColumn('estadoSolicitud', 'Estado', 120, ({ getValue }) => {
		const value = getValue() as ILookup;
		return (
			<TextIcon
				isFit
				iconLeft={{
					color: SOLICITUD_ESTADOS_COLOR[value?.id as keyof typeof SOLICITUD_ESTADOS_COLOR],
					icon: 'status',
				}}
				description={value?.descripcion}
			/>
		);
	}),
	setColumn('tipoTramite', 'Tipo de negocio jurídico', undefined, ({ getValue }) => {
		const value = getValue() as ISolicitud['tipoTramite'];
		return <CTNEllipsis content={value?.descripcion} />;
	}),
];

export default getColumns;